// extracted by mini-css-extract-plugin
export var pageTitle = "PageTitle-module--pageTitle--gY10-";
export var pageTitle__text = "PageTitle-module--pageTitle__text--IohD-";
export var pageTitle_isMain = "PageTitle-module--pageTitle_isMain--OMNxf";